/**
 * GraphQL getAutomatedColumns expects data: [[automatedCellConfig]].
 * Table values often store static labels as plain strings (e.g. "Rendite").
 */
export function normalizeAutomatedCellConfig(cell: unknown): Record<string, unknown> {
  if (cell === null || cell === undefined) {
    return { text: '', isDynamic: false };
  }
  if (typeof cell === 'string') {
    return { text: cell, isDynamic: false };
  }
  if (typeof cell === 'number' || typeof cell === 'boolean') {
    return { text: String(cell), isDynamic: false };
  }
  if (typeof cell === 'object') {
    const config = cell as Record<string, unknown>;
    if (config.isDynamic && Array.isArray(config.fields) && config.fields.length > 0) {
      return config;
    }
    return {
      ...config,
      isDynamic: config.isDynamic ?? false,
      text:
        typeof config.text === 'string'
          ? config.text
          : typeof config.linkText === 'string'
            ? config.linkText
            : '',
    };
  }
  return { text: String(cell), isDynamic: false };
}

export function normalizeAutomatedColumnsInput(values: unknown[][]): Record<string, unknown>[][] {
  if (!Array.isArray(values)) return [];
  return values.map((row) =>
    (Array.isArray(row) ? row : []).map((cell) => normalizeAutomatedCellConfig(cell)),
  );
}
